import {
  Box,
  Divider,
  Image,
  Text,
  List,
  OrderedList,
  UnorderedList,
  ListIcon,
  ListItem,
  Tab,
  Tabs,
  TabList,
  TabPanel,
  TabPanels
} from '@chakra-ui/react';
import React from 'react';
import { VscDash } from 'react-icons/vsc';

import PageContainer from '../../components/pageContainer/PageContainer';

import intermediarySs1 from './intermediary1.png';
import intermediaryGif from './intermediaryGif.gif';
import issuerSs1 from './issuer1.png';
import issuerGif2 from './issuer2.gif';
import normalUserGif from './normalUserGif.gif';

function Navigates() {
  return (
    <PageContainer>
      <Text color='#377DFF' fontSize='2xl' fontWeight={600} marginBottom='50px'>Navigating the portal</Text>
      <Box w='70%'>
        <Text textAlign='left' fontSize='xl' fontWeight={500}>Navigation Bar: </Text>
        <UnorderedList textAlign='left' spacing={3}>
          <ListItem>
            <Text>To log in to the portal or log out of the portal, click on <Text fontWeight='bold' as='span'>Log In</Text> or <Text fontWeight='bold' as='span'>Log Out</Text></Text>
          </ListItem>
          <ListItem>To create an account, click on <Text fontWeight='bold' as='span'>Sign Up</Text></ListItem>
          <ListItem>For contact information, click on <Text fontWeight='bold' as='span'>Contact</Text></ListItem>
          <ListItem>To verify a certifcate, click on <Text fontWeight='bold' as='span'>Verify Certificate</Text></ListItem>
        </UnorderedList>
      </Box>
      <Divider marginY='25px'/>
      <Box w='70%'>
        <Text textAlign='left' fontSize='xl' fontWeight={500}>How to use the portal: </Text>
        <UnorderedList textAlign='left' spacing={3}>
          <ListItem>
            <Text>There are 3 different types of accounts:</Text>
            <List textAlign='left'>
              <ListItem><ListIcon as={VscDash}/>Certificate Issuer</ListItem>
              <ListItem><ListIcon as={VscDash}/>Intermediary Role</ListItem>
              <ListItem><ListIcon as={VscDash}/>Normal User</ListItem>
            </List>
          </ListItem>
          <ListItem>All accounts are created as a Normal User by default</ListItem>
          <ListItem>If you wish to upgrade your account to a Certificate Issuer or a Intermediary Role, you can send an upgrade request with your entity name and contact us using the contact information found in our <Text fontWeight='bold' as='span'>Contact</Text> page</ListItem>
          <ListItem>Instructions on how to use the portal for each account type can be found right below here:</ListItem>
        </UnorderedList>
        <Tabs>
          <TabList>
            <Tab>Intermediary Role</Tab>
            <Tab>Certificate Issuer</Tab>
            <Tab>Normal User Verifier</Tab>
          </TabList>

          <TabPanels textAlign='left'>
            <TabPanel>
              <Text fontWeight='bold'>The home page will redirect you to the verification screen </Text>
              <Image src={intermediarySs1}/>
              <Text fontWeight='bold'>You can start keying in information to verify the product</Text>
              <Image src={intermediaryGif}/>
            </TabPanel>
            <TabPanel>
              <Text fontWeight='bold'>The home page will have a table containing the details of all the productions which you have created</Text>
              <Image src={issuerSs1}/>
              <br/>
              <Text fontWeight='bold'>Click on the <Text fontWeight='bold' as='span'>Add a new production</Text> button and fill in the production name/year to create a new production entry</Text>
              <Image src={issuerGif2}/>
              <br/>
              <Text fontWeight='bold'>After creating, you will have to upload and provide different data before the certificates can be issued</Text>
              <OrderedList textAlign='left' spacing={3}>
                <OrderedList textAlign='left' spacing={3}>
                  <ListItem>
                    Upload a <Text as='span' textDecor='underline'>CSV</Text> file containing the details of the product batches in the production.
                    <br/>
                    The CSV file <Text as='span' textDecor='underline'>must</Text> contain a column storing the <Text as='span' textDecor='underline'>Batch Number, Quantity, Manufacturing Date and Expiry Date</Text>. The <Text as='span' textDecor='underline'>Batch Number</Text> has to be <Text as='span' textDecor='underline'>unique</Text>.
                  </ListItem>
                  <ListItem>Issue the certificates</ListItem>
                </OrderedList>
              </OrderedList>
              <br/>
              <Text fontWeight='bold'>You can download the zip file containing the QR codes generated for the corresponding production</Text>
              <br/>
              <Text fontWeight='bold'>To analyse and view the scan statistics, you can download the Excel Scan Statistics file with 1 click</Text>
              <br/>
              <Text fontWeight='bold'>Set the Scan Threshold so the system can notify you if there is unsual scan behavior with regards to the production</Text>
              <Text>With regards to Set the Scan Threshold, it is the maximum permitted successful scan at an unintended location.</Text>
            </TabPanel>
            <TabPanel>
              <Text fontWeight='bold'>
                The home page will have a form to upgrade your account type, you need to provide:
              </Text>
              <OrderedList textAlign='left' spacing={3}>
                <OrderedList textAlign='left' spacing={3}>
                  <ListItem>
                    Account Type to be upgraded to
                  </ListItem>
                  <ListItem>Entity Name of your organisation</ListItem>
                </OrderedList>
              </OrderedList>
              <Image src={normalUserGif}/>
            </TabPanel>
          </TabPanels>
        </Tabs>
      </Box>
    </PageContainer>
  );
}

export default Navigates;
